define('views/components/cd_settings/password_settings',['require','backbone','marionette','jquery-validation','text!templates/components/cd_settings/password_settings.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('jquery-validation');

    var temp = require("text!templates/components/cd_settings/password_settings.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'page',

        ui: function() {
            return {
                mainForm : '#main-form',
                passwordField: '#password',
                passwordConfirmField: '#password_confirm',
                submitButton: '#submit-button'
            };
        },

        events: {
            'click @ui.submitButton': 'submitButtonClicked'
        },

        onRender: function () {
            this.ui.mainForm.validate({
                rules: {
                    'password': "required",
                    'password_confirm': {
                        equalTo: '[name="password"]'
                    }
                },
                messages: {
                    'password': App.polyglot.t('password_required'),
                    'password_confirm': {
                        equalTo: App.polyglot.t('password_confirm_must_match')
                    }

                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        submitButtonClicked: function () {
            var _this = this;

            if (this.ui.mainForm.valid()) {

                this.ui.submitButton.addClass('loading');

                $.ajax({
                    url: App.Config.apiBase + 'users/change_password/',
                    method: 'post',
                    data: {
                        password: this.ui.passwordField.val(),
                        password_confirm: this.ui.passwordConfirmField.val()
                    },
                    success:function(response) {
                        _this.ui.submitButton.removeClass('loading');

                        App.utils.showMessage('success', App.polyglot.t('password_reset_success'));

                        // Clear password fields
                        _this.ui.passwordField.val('');
                        _this.ui.passwordConfirmField.val('');
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        _this.ui.submitButton.removeClass('loading');

                        // Show error messages
                        if (xhr.responseJSON.errors) {
                            for (var i=0; i<xhr.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                            }
                        }
                    }
                });
            }
        }


    });
});
